import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { FarmShrimpPrice, Region } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store";
import { withBaseModel } from "../extensions/with-base-model"
import SyncableModel from "../../database/SyncableModel"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import JalaAnalytic from "../../utils/jala-analytic"

const FarmShrimpPriceStoreProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const FarmShrimpPriceStoreModel = types
  .model("FarmShrimpPriceStore")
  .props(FarmShrimpPriceStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof FarmShrimpPriceStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async storeToServer(data) {
      if (data && data.farm_id && data.shrimp_price_id) {
        const deletedModels = await FarmShrimpPrice.fetch({
          farm_id__eq: data.farm_id,
          shrimp_price_id__gte: data.shrimp_price_id
        });
        for (let i = 0; i < deletedModels.length; i++) {
          await this.delete(deletedModels[i]);
        }
      }
      return self.storeModelToServer(FarmShrimpPrice, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: home - confirm prediksi jual');
          return success;
        });
    },
    async store(data) {
      return this.storeToServer(data);
      // return self.storeModel(FarmShrimpPrice, data);
    },
    async updateToServer(model: SyncableModel, data) {
      return self.updateModelToServer(FarmShrimpPrice, model, data);
    },
    async update(model: SyncableModel, data) {
      return this.updateToServer(model, data);
      // return self.updateModel(FarmShrimpPrice, model, data);
    },
    async deleteFromServer(model: SyncableModel) {
      return self.deleteModelFromServer(FarmShrimpPrice, model);
    },
    async delete(model: SyncableModel) {
      return this.deleteFromServer(model)
      // return self.deleteModel(FarmShrimpPrice, model);
    },

    async getRegion(id) {
      const models = await Region.fetch({
        id__eq: id
      }).catch((e) => {
        console.warn(e)
        this.set('error', e);
        return []
      }).then((regions) => regions ? regions.map((model) => model.toArray()) : null)
      return models
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type FarmShrimpPriceStoreType = Instance<typeof FarmShrimpPriceStoreModel>
export interface FarmShrimpPriceStore extends FarmShrimpPriceStoreType {}
type FarmShrimpPriceStoreSnapshotType = SnapshotOut<typeof FarmShrimpPriceStoreModel>
export interface FarmShrimpPriceStoreSnapshot extends FarmShrimpPriceStoreSnapshotType {}
export const createFarmShrimpPriceStoreDefaultModel = () => types.optional(FarmShrimpPriceStoreModel, {})
